import {
  Icon,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
} from "@salestrak/ui";
import React from "react";

import { useSidebarNav } from "../use-sidebar-nav";
import { useInboxUnreadCount } from "#app/hooks/inbox/use-inbox-unread-count";
import { useWidgetsFlag } from "#app/lib/hooks/use-widgets-flag";
import { useFeatureFlags } from "#app/hooks/use-feature-flags";

/**
 * Home's primary destinations: My Work (flag-gated widget view) + Inbox (live
 * unread badge). With WIDGETS off, My Work gives way to the legacy Dashboard
 * row pointing at the workspace root, where the pre-widgets Home dashboard
 * still renders (its removal is gated behind the flag).
 */
export function HomeNavSection() {
  const { navigate, isActive } = useSidebarNav();
  const inboxUnreadCount = useInboxUnreadCount();
  // My Work rides the same WIDGETS flag as the rest of the widget-view hosts.
  const myWorkEnabled = useWidgetsFlag();
  // The legacy Dashboard row only renders once flags have RESOLVED to off —
  // `useWidgetsFlag` is false while loading, and the legacy row flashing in
  // during the fetch would be worse than it arriving late.
  const { ready: flagsReady } = useFeatureFlags();

  return (
    <SidebarGroup>
      <SidebarMenu>
        {myWorkEnabled ? (
          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isActive("/my-work")}
              onClick={() => navigate("/my-work")}
            >
              <Icon name="briefcase" />
              <Text truncate>My Work</Text>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ) : null}
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isActive("/inbox")}
            onClick={() => navigate("/inbox")}
          >
            <Icon name="inbox" />
            <Text truncate>Inbox</Text>
          </SidebarMenuButton>
          {/* The unread count is the sidebar's own badge slot — positioned
            * against the row, outside the button, so it never competes with
            * the label for truncation. */}
          {inboxUnreadCount > 0 && (
            <SidebarMenuBadge>{inboxUnreadCount}</SidebarMenuBadge>
          )}
        </SidebarMenuItem>
        {flagsReady && !myWorkEnabled ? (
          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isActive("/")}
              onClick={() => navigate("/")}
            >
              <Icon name="home" />
              <Text truncate>Dashboard</Text>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ) : null}
      </SidebarMenu>
    </SidebarGroup>
  );
}
